var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-wrap",style:({ background: 'url(' + _vm.userData.pc_loginback_img + ')' })},[_c('loginPage',{staticStyle:{"min-width":"1200px","min-height":"900px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }